<template>
  <div class="counter-picker justify-center layout px-0">
    <v-icon small @click="setValue(localValue - 1)">keyboard_arrow_down</v-icon>
    <!-- <i :class="'fa fa-angle-down ' + ((localValue <= min) ? ' ' : '')"></i> -->
    <div class="counter-picker__value">{{ localValue }}</div>
    <v-icon small @click="setValue(localValue + 1)">keyboard_arrow_up</v-icon>
    <!-- <i
      :class="'fa fa-angle-up ' + ((localValue >= max) ? ' inactive' : '')"
      @click="setValue(localValue + 1)"
    ></i>-->
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: 0
    },

    min: {
      type: Number,
      default: 0
    },

    max: {
      type: Number,
      default: 99999
    },

    label: {
      type: String,
      default: "Label"
    }
  },

  data() {
    return {
      localValue: parseInt(this.value)
    };
  },

  watch: {
    value(newVal, oldVal) {
      this.localValue = parseInt(newVal);
    },

    localValue(newVal, oldVal) {
      this.$emit("input", this.localValue);
    }
  },

  methods: {
    setValue(value) {
      if (value >= this.min && value <= this.max) {
        this.localValue = value;
      }
    }
  }
};
</script>
